<template>
  <div
    class="relative flex h-full w-full flex-col justify-between gap-6 rounded-md border border-light-gray p-5"
  >
    <div>
      <div class="flex w-full items-center gap-4">
        <h3 class="text-base text-dark-gray lg:text-xl">Assessment</h3>
        <div class="flex items-center">
          <custom-badge
            v-if="overallResult?.length > 0"
            :bg-color-class="ratingBgColorClass(overallResult)"
            size="lg"
            class="inline-flex self-start capitalize"
            :text="overallResult"
          />
        </div>
      </div>
      <div class="mt-8 flex">
        <div class="flex flex-wrap gap-4">
          <custom-badge
            bg-color-class="bg-white"
            color-class="text-dark-gray"
            size="md"
            icon-size="lg"
            text="Active Authority"
            :icon="iconName(assessment?.active_authority)"
            :icon-color-class="iconColorClass(assessment?.active_authority)"
            class="inline-flex self-start border pt-1.5"
          />
          <custom-badge
            bg-color-class="bg-white"
            color-class="text-dark-gray"
            size="md"
            icon-size="lg"
            text="Digital Activity in USA"
            :icon="iconName(assessment?.digital_activity_in_usa)"
            :icon-color-class="
              iconColorClass(assessment?.digital_activity_in_usa)
            "
            class="inline-flex self-start border pt-1.5"
          />
          <custom-badge
            bg-color-class="bg-white"
            color-class="text-dark-gray"
            size="md"
            icon-size="lg"
            text="Credit Approval by Triumph Financial"
            :icon="iconName(assessment?.credit_approved)"
            :icon-color-class="iconColorClass(assessment?.credit_approved)"
            class="inline-flex self-start border pt-1.5"
          />
        </div>
      </div>
    </div>
    <div class="text-left text-3xs text-gray-over-dark">
      Assessment conducted using government data and internal database.
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';

export default {
  name: 'AssessmentSection',
  components: {
    CustomBadge,
  },
  props: {
    assessment: {
      type: Object,
      required: true,
    },
    overallResult: {
      type: String,
      required: true,
    },
  },
  methods: {
    ratingBgColorClass: function (rating) {
      switch (rating) {
        case 'fail':
          return 'bg-orange-200 text-orange-600';
        case 'pass':
          return 'bg-green-200 text-green-600';
        case 'incomplete':
          return 'bg-light-gray text-gray-over-dark';
        default:
          return 'bg-light-gray text-gray-over-dark';
      }
    },
    iconColorClass: function (rating) {
      switch (rating) {
        case 'pass':
          return 'text-green-500';
        case 'fail':
          return 'text-orange-500';
        default:
          return 'text-body-color';
      }
    },
    iconName: function (rating) {
      switch (rating) {
        case 'pass':
          return 'checkmark';
        case 'fail':
          return 'exclamation';
        case 'incomplete':
          return 'exclamation';
        default:
          return 'exclamation';
      }
    },
  },
};
</script>
